import { render, staticRenderFns } from "./LinkPreviewToggle.vue?vue&type=template&id=6c50da8e&"
import script from "./LinkPreviewToggle.vue?vue&type=script&lang=js&"
export * from "./LinkPreviewToggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports